import React,{useState} from 'react'
import { useDispatch } from 'react-redux';
import { addItem } from '../store/slices/cartSlice';
import {addWishlist} from '../store/slices/favoriteSlice';

export default function ProductsCard (props) {

  const{img,rating,title,price}=props;

  const[isAdded,setIsAdded]=useState(false);

  const dispatch=useDispatch();

  const handleAddToCart=()=>{

    const item={...props};
    dispatch(addItem(item));

    setIsAdded(true);

    setTimeout(()=>{
      setIsAdded(false);
    },3000);
  }
  const handleAddToFavorite=()=>{

    const item={...props};
    dispatch(addWishlist(item));
   
  }
  return (
    <div>
    <div className="product_card">
    <div
       title="Favorite"
       className="favorite_icon" >
       <button onClick={handleAddToFavorite}>< img src="/images/fav.jpg" alt="favorite-icon"/> </button>
   </div>
    <figure>
        <img src={img} alt="item-img" />
    </figure>
    <strong className="rating">{rating}</strong>
    <h4 className="title">{title}</h4>
    <h3 className="price">₹ {price.toLocaleString()}</h3>
    <button
        type="button"
        className={`btn ${isAdded ? 'added' : ''}`}
        onClick={handleAddToCart}
    >
        {isAdded ? 'Added' : 'Add to cart'}
    </button>
  
</div>
    </div>
  )
}
